'use client';

import React, { useRef, useState, useEffect } from "react";
import "../assets/styles/YoutubeSection.scss";

const featuredVideo = {
  title: "Practice Deep Learning - Lecture Series",
  embedId: "XEr7B_uVNXk",
  description:
    "This is an introductory video for our course. We explore how to build a classification system using Fastai, extending the Practical Deep Learning 2022 series with added notes and slides.",
};

const videos = [
  { title: "Introduction to C++", embedId: "Rlsb9RnVVSQ" },
  { title: "NLP With Code - Playlist", embedId: "XM_m0x4QVNM" },
  { title: "Practical Session - Playlist - AI", embedId: "IEMHjCt8fsw" },
  { title: "Walk with Fastai Lecture Series By Doha & Hassan", embedId: "yC4VUVDELes" },
  { title: "How to Debug Code in C++ - Visual Studio Code MacOs", embedId: "AOVueg2gOqk" },
];

const channelUrl = "https://www.youtube.com/@hafizDS";
const channelUrl2 = "https://www.youtube.com/@NextrickLearning";

export default function YouTubeSection() {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      if (!scrollRef.current) return;
      const scrollLeft = scrollRef.current.scrollLeft;
      const card = scrollRef.current.querySelector(".video-card");
      const cardWidth = card?.clientWidth || 300;
      const index = Math.round(scrollLeft / (cardWidth + 30)); // 30px gap
      setActiveIndex(index);
    };

    const ref = scrollRef.current;
    if (ref) {
      ref.addEventListener("scroll", handleScroll);
      return () => ref.removeEventListener("scroll", handleScroll);
    }
  }, []);

  return (
    <div className="videos-container" id="videos">
      <h1>YouTube Highlights</h1>
      <p>My team at Nextrick created free playlists on Deep Learning and NLP.</p>

      {/*<div className="featured-video">
        <h2>{featuredVideo.title}</h2>
        <p>{featuredVideo.description}</p>
        <div className="video-frame">
          <iframe
            src={`https://www.youtube.com/embed/${featuredVideo.embedId}`}
            title={featuredVideo.title}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
      </div>*/}

      <div className="videos-scroll" ref={scrollRef}>
        {videos.map((video, index) => (
          <div className="video-card zoom" key={index}>
            <div className="video-frame">
              <iframe
                src={`https://www.youtube.com/embed/${video.embedId}`}
                title={video.title}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
            <h2>{video.title}</h2>
          </div>
        ))}
      </div>

      <div className="scroll-dots">
        {videos.map((_, index) => (
          <span
            key={index}
            className={`dot ${index === activeIndex ? "active" : ""}`}
          ></span>
        ))}
      </div>

      <div className="video-actions">
        <a
          href={`${channelUrl}?sub_confirmation=1`}
          target="_blank"
          rel="noreferrer"
          className="subscribe-button"
        >
          Subscribe Me
        </a>
        <a
          href={channelUrl}
          target="_blank"
          rel="noreferrer"
          className="view-more-link"
        >
          [View More]
        </a>
        <a
          href={`${channelUrl2}?sub_confirmation=1`}
          target="_blank"
          rel="noreferrer"
          className="subscribe-button"
        >
          Subscribe Nextrick
        </a>
        <a
          href={channelUrl2}
          target="_blank"
          rel="noreferrer"
          className="view-more-link"
        >
          [View More]
        </a>
      </div>
    </div>
  );
}
